import { Link } from "react-router-dom";

export const Logo = ({ className = "h-11", testid = "nav-logo-link", to = "/" }) => (
  <Link to={to} data-testid={testid} className="inline-flex items-center">
    <img src="/logo.jpeg" alt="FosterApp - Explore to Excel" className={`${className} w-auto rounded-md object-contain`} />
  </Link>
);
